// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-padding: 12px;
}

.form-row {
  height: 100%;
}
.form-row > ion-col {
  height: 100%;
}

swiper-container {
  height: 100%;
}

.margin-top-value {
  margin-top: 10px;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  overflow: auto;
}

.wrapper-basket {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--color-black);
}
.wrapper-basket .article-wrappers {
  flex-grow: 1;
  padding-top: 10px;
  overflow-y: auto;
}
.wrapper-basket .footer {
  border-top: 1px solid var(--color-black);
  padding-top: 10px;
  width: 100%;
}
.wrapper-basket .footer.footer-block {
  padding: 20px;
}
.wrapper-basket .footer ion-button {
  width: 100%;
  --border-radius: 300px;
}
.wrapper-basket .footer .tips {
  border-bottom: 1px solid var(--color-black);
  padding-bottom: 10px;
  padding-top: 10px;
}

.form-card {
  padding: 25px;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  overflow-x: hidden;
}
.form-card .cross-icon {
  z-index: 5;
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.form-card .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.form-card .title {
  padding: 10px 0px;
  font-size: 20px;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
}
@media (min-width: 991px) {
  .form-card .title {
    margin-bottom: 30px;
  }
}
.form-card .wrapper-for-inputs {
  flex-grow: 1;
}
.form-card .footer {
  width: 100%;
}
.form-card .footer .footer-btn {
  width: 100%;
  --border-radius: 300px;
}
.form-card .footer .footer-btn:hover {
  --background: var(--primary-btn) !important;
}

.button-row {
  padding: 20px 10px 20px 20px;
}
.button-row .sub-total {
  padding: 0 0 10px;
}
.button-row .total {
  padding: 0;
}

.error_container {
  height: 12px;
  position: relative;
  margin-bottom: 5px;
  margin-top: 5px;
}

.input_group {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 10px;
  align-items: center;
}
.input_group--1 {
  grid-column: span 8;
}
.input_group--2 {
  grid-column: span 4;
}

.error-phone,
.error-email {
  left: 18px;
}
.error-phone .input_info,
.error-email .input_info {
  position: absolute;
  top: 0;
}

.privacy-checkbox {
  border: none;
  font-size: 12px;
  font-weight: 400;
  margin-left: -15px;
}

.error-text {
  color: rgb(119, 25, 25);
  font-size: 12px;
  font-family: var(--ion-font-family);
  margin-left: 20px;
}

.legacy-term {
  text-transform: none;
  z-index: 9999;
}
.legacy-term a {
  text-decoration: underline;
}

.add-promo-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 10px;
  padding-left: 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--color-black);
}
.add-promo-card ion-icon {
  width: 32px;
  height: 32px;
}
.add-promo-card ion-label {
  font-size: 14px;
  font-family: var(--ion-font-family);
  color: var(--color-dark-gray);
  text-transform: uppercase;
}

.email-note {
  text-transform: none;
  font-style: italic;
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAGA;EACC,YAAA;AAAD;AAEC;EACC,YAAA;AAAF;;AAGA;EACC,YAAA;AAAD;;AAEA;EACC,gBAAA;AACD;;AACA;EACC,sBAAA;EACA,uBAAA;AAED;;AACA;EACC,cAAA;AAED;;AAAA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;AAGD;AAFC;EACC,YAAA;EACA,iBAAA;EACA,gBAAA;AAIF;AAFC;EACC,wCAAA;EACA,iBAAA;EACA,WAAA;AAIF;AAHE;EACC,aAAA;AAKH;AAHE;EACC,WAAA;EACA,sBAAA;AAKH;AAHE;EACC,2CAAA;EACA,oBAAA;EACA,iBAAA;AAKH;;AADA;EACC,aAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAID;AAHC;EACC,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAIF;AAHE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAKH;AAFC;EACC,iBAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;AAIF;ACvFE;ED+ED;IAME,mBAAA;EAMD;AACF;AAHC;EACC,YAAA;AAKF;AAHC;EACC,WAAA;AAKF;AAJE;EACC,WAAA;EACA,sBAAA;AAMH;AALG;EACC,2CAAA;AAOJ;;AADA;EACC,4BAAA;AAID;AAFC;EACC,iBAAA;AAIF;AADC;EACC,UAAA;AAGF;;AACA;EACC,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAED;;AACA;EACC,aAAA;EACA,sCAAA;EACA,SAAA;EACA,mBAAA;AAED;AAAC;EACC,mBAAA;AAEF;AACC;EACC,mBAAA;AACF;;AAEA;;EAEC,UAAA;AACD;AAAC;;EACC,kBAAA;EACA,MAAA;AAGF;;AAAA;EACC,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAGD;;AADA;EACC,uBAAA;EACG,eAAA;EACH,mCAAA;EACA,iBAAA;AAID;;AAFA;EACC,oBAAA;EACA,aAAA;AAKD;AAJC;EACC,0BAAA;AAMF;;AAHA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACG,kBAAA;EACH,eAAA;EACA,2CAAA;AAMD;AALC;EACC,WAAA;EACA,YAAA;AAOF;AALC;EACC,eAAA;EACA,mCAAA;EACA,6BAAA;EACA,yBAAA;AAOF;;AAJA;EACC,oBAAA;EACG,kBAAA;EACA,gBAAA;AAOJ","sourcesContent":["@import '../../../theme/mixins';\n\n:root {\n\t--ion-padding: 12px;\n}\n.form-row {\n\theight: 100%;\n\n\t& > ion-col {\n\t\theight: 100%;\n\t}\n}\nswiper-container {\n\theight: 100%;\n}\n.margin-top-value {\n\tmargin-top: 10px;\n}\nion-slides {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nswiper-slide {\n\toverflow: auto;\n}\n.wrapper-basket {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tborder-right: 1px solid var(--color-black);\n\t.article-wrappers {\n\t\tflex-grow: 1;\n\t\tpadding-top: 10px;\n\t\toverflow-y: auto;\n\t}\n\t.footer {\n\t\tborder-top: 1px solid var(--color-black);\n\t\tpadding-top: 10px;\n\t\twidth: 100%;\n\t\t&.footer-block {\n\t\t\tpadding: 20px;\n\t\t}\n\t\tion-button {\n\t\t\twidth: 100%;\n\t\t\t--border-radius: 300px;\n\t\t}\n\t\t.tips {\n\t\t\tborder-bottom: 1px solid var(--color-black);\n\t\t\tpadding-bottom: 10px;\n\t\t\tpadding-top: 10px;\n\t\t}\n\t}\n}\n.form-card {\n\tpadding: 25px;\n\tposition: relative;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: auto;\n\toverflow-x: hidden;\n\t.cross-icon {\n\t\tz-index: 5;\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t}\n\t.title {\n\t\tpadding: 10px 0px;\n\t\tfont-size: 20px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\ttext-transform: uppercase;\n\t\t@include desktop {\n\t\t\tmargin-bottom: 30px;\n\t\t}\n\t}\n\n\t.wrapper-for-inputs {\n\t\tflex-grow: 1;\n\t}\n\t.footer {\n\t\twidth: 100%;\n\t\t.footer-btn {\n\t\t\twidth: 100%;\n\t\t\t--border-radius: 300px;\n\t\t\t&:hover {\n\t\t\t\t--background: var(--primary-btn) !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.button-row {\n\tpadding: 20px 10px 20px 20px;\n\n\t.sub-total {\n\t\tpadding: 0 0 10px;\n\t}\n\n\t.total {\n\t\tpadding: 0;\n\t}\n}\n\n.error_container {\n\theight: 12px;\n\tposition: relative;\n\tmargin-bottom: 5px;\n\tmargin-top: 5px;\n}\n\n.input_group {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(12, 1fr);\n\tgap: 10px;\n\talign-items: center;\n\n\t&--1 {\n\t\tgrid-column: span 8;\n\t}\n\n\t&--2 {\n\t\tgrid-column: span 4;\n\t}\n}\n.error-phone,\n.error-email {\n\tleft: 18px;\n\t.input_info {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t}\n}\n.privacy-checkbox {\n\tborder: none;\n\tfont-size: 12px;\n\tfont-weight: 400;\n\tmargin-left: -15px;\n}\n.error-text {\n\tcolor: rgb(119, 25, 25);\n    font-size: 12px;\n\tfont-family: var(--ion-font-family);\n\tmargin-left: 20px;\n}\n.legacy-term {\n\ttext-transform: none;\n\tz-index: 9999;\n\ta {\n\t\ttext-decoration: underline;\n\t}\n}\n.add-promo-card {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\tpadding-bottom: 10px;\n    padding-left: 12px;\n\tcursor: pointer;\n\tborder-bottom: 1px solid var(--color-black);\n\tion-icon {\n\t\twidth: 32px;\n\t\theight: 32px;\n\t}\n\tion-label {\n\t\tfont-size: 14px;\n\t\tfont-family: var(--ion-font-family);\n\t\tcolor: var(--color-dark-gray);\n\t\ttext-transform: uppercase;\n\t}\n}\n.email-note {\n\ttext-transform: none;\n    font-style: italic;\n    margin-left: 5px;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
